import DateFnsUtils from "@date-io/date-fns";
import {
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  withStyles,
} from "@material-ui/core";
import { Input as AntInput, Select as AntSelect } from "antd";
import { LIST_MISSION_TYPES } from "constant/ticket";
import { FieldArray, FormikProvider, useFormik } from "formik";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import moment from "moment";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";

import { get, postRequest, putRequest } from "../../api/apiCaller";
import { getData } from "../../api/apiCaller";
import Autocomplete from "../../components/Autocomplete";
import DialogDragable from "../../components/DialogDragable";
import {
  FONT_SIZE_DEFAULT,
  FONT_SIZE_SMALL,
  HEIGHT_RESIZE,
  SERVICES,
  SERVICES_OPTIONS,
  TRANSFER_UNITS,
  WIDTH_RESIZE,
} from "./Constant";
import PackageInfo from "./PackageInfo";

const styles = (theme) => {
  return {
    padding0: {
      padding: "0px !important",
    },
    textFieldTicketDetail: {
      minHeight: "29px !important",
    },
    textSmall: {
      fontSize: 12,
      [theme.breakpoints.down(WIDTH_RESIZE)]: { fontSize: 11 },
    },
    iconButton: {
      padding: "6px",
    },
    titleFlex: {
      flexShrink: 0,
      marginRight: 5,
      marginTop: 6,
      [theme.breakpoints.down(WIDTH_RESIZE)]: { marginTop: 0 },
    },
    titlePackageCode: {
      marginTop: 15,
      [theme.breakpoints.down(WIDTH_RESIZE)]: { marginTop: 10 },
    },
    inputSelect: {
      padding: "14px",
    },
    row: {
      marginTop: 15,
      [theme.breakpoints.down(WIDTH_RESIZE)]: { marginTop: 5 },
    },
    textFieldOutlinedInputRoot: {
      fontSize: FONT_SIZE_DEFAULT,
      padding: 15,
      minHeight: 0,
      [theme.breakpoints.down(WIDTH_RESIZE)]: {
        padding: 10,
        fontSize: FONT_SIZE_SMALL,
      },
      [`@media (max-height:${HEIGHT_RESIZE}px)`]: {
        padding: 7,
      },
    },
  };
};

const phoneReg = /((84|0)[3|5|7|8|9])+([0-9]{8})\b/;

let timeout = null;
const searchProvince = async (value, callback) => {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  timeout = setTimeout(function () {
    callback(20, value);
  }, 900);
};

const NewTicket = ({
  onRefreshListPhone,
  idTicketPhone,
  phoneTab,
  styles,
  classes,
  showHeader = true,
  customerInfoDefault,
  onClose,
  idSelectedCustomerCall,
}) => {
  const listTicketTypes = useSelector((state) => state.ticket.ticketType);
  const { enqueueSnackbar } = useSnackbar();

  const [productOptions, setProductOptions] = useState([]);
  const [openDialogPackage, setOpenDialogPackage] = useState(false);
  const [packageInfo, setPackageInfo] = useState();
  const [packageCode, setPackageCode] = useState("");
  const [isLoadingPackage, setIsLoadingPackage] = useState(false);
  const [isCanEdit, setIsCanEdit] = useState(false);
  const [hostUnit, setHostUnit] = useState(null);
  const [hostUnitName, setHostUnitName] = useState(null);
  const customerNameInputRef = useRef();
  const [customerInfo, setCustomerInfo] = useState({
    customerName: "",
    customerPhone: "",
    customerAddress: "",
    customerEmail: "",
  });
  const [subOrgs, setSubOrgs] = useState([]);

  useEffect(() => {
    getProvice(20);
  }, []);

  const validationSchemaCustomerInfo = Yup.object().shape({
    customerName: Yup.string().required("Không được trống"),
    customerPhone: Yup.string()
      // .matches(phoneReg, "Không đúng định dạng")
      .required("Không được trống"),
    // customerEmail: Yup.string().email("Email không đúng định dạng"),
    customerAddress: Yup.string(),
  });

  const validationSchemaTicket = Yup.lazy((values) => {
    return Yup.object().shape({
      service: Yup.object().nullable(),
      product: Yup.string(),
      // packageCode: Yup.string().required(
      //   " Mã tin thu gom/Mã vận đơn không được trống"
      // ),
      type: Yup.string().required("Loại yêu cầu không được trống"),
      ...(!!getTicketTypes(values.type).length && {
        ticketDetail: Yup.string().required(
          "Nội dung yêu cầu không được trống"
        ),
      }),
      // ...(isTicketType("tư vấn dịch vụ") && {
      //   transferUnit: Yup.object().shape({
      //     code: Yup.string().required("Không được trống"),
      //   }),
      // }),
      ...(values.moreMisson && {
        task: Yup.array().of(
          Yup.object().shape({
            description: Yup.string().required(
              "Chi tiết nhiệm vụ không được trống"
            ),
            type: Yup.string().required("Loại nhiệm vụ không được trống"),
            actionDate: Yup.string().required(
              "Thời gian thực hiện không được trống"
            ),
          })
        ),
      }),
      description: Yup.string().required("Chi tiết yêu cầu không được trống"),
    });
  });

  const getProvice = async (limit, fullname, citycode, districtcode) => {
    const where = {
      ...(fullname && { fullname: { like: fullname, options: "i" } }),
      ...(citycode && !districtcode && { citycode }),
      ...(districtcode && { districtcode }),
    };
    const { data } = await getData("/vnpost/province", {
      filter: { where, limit },
      getAll: 1,
    });
    setSubOrgs(data);
  };

  const handleSearchPackage = (pakageCodeSearchValue) => {
    setPackageInfo(null);
    setPackageCode(pakageCodeSearchValue);
    setOpenDialogPackage(true);

    if (pakageCodeSearchValue) {
      handleGetInfoPackage(pakageCodeSearchValue);
    }
  };

  const handleSubmitCustomerInfo = (values, { setSubmitting }) => {
    const customerSubmitValue = {
      customerName: values.customerName?.trim() || "",
      customerPhone: values.customerPhone?.trim() || "",
      customerAddress: values.customerAddress?.trim() || "",
      customerEmail: values.customerEmail?.trim() || "",
    };

    postRequest(
      `/mini-crm/vnpost-crm-gateway/post-contact-crm-vnpost`,
      customerSubmitValue
    )
      .then((res) => {
        if (res.data) {
          enqueueSnackbar("Lưu thông tin khách hàng thành công", {
            variant: "success",
          });
          setCustomerInfo(customerSubmitValue);
          formCustomerInfo.setValues(customerSubmitValue);
          setIsCanEdit(false);
        } else {
          enqueueSnackbar("Lưu thông tin khách hàng thất bại!", {
            variant: "error",
          });
        }
        setSubmitting(false);
      })
      .catch((err) => {
        enqueueSnackbar(
          `Lưu thông tin khách hàng thất bại! ${
            err.response?.data?.error?.message || err.message || ""
          }`,
          {
            variant: "error",
          }
        );
        setSubmitting(false);
      });
  };

  const handleGetInfoPackage = (packageCode) => {
    setIsLoadingPackage(true);
    get(`/mini-crm/vnpost-crm-gateway/get-package?packageId=${packageCode}`)
      .then((res) => {
        if (res.data?.dinhvi) res.data.dinhvi.reverse();
        setPackageInfo(res.data);
        setHostUnit(res.data?.info?.buu_cuc_nhan);
        setHostUnitName(res.data?.info?.buu_cuc_gui);
        setIsLoadingPackage(false);
      })
      .catch((err) => {
        setIsLoadingPackage(false);
      });
  };

  const createRequestBody = (values) => ({
    type: values.type,
    tasks: values.task,
    attributes: {
      service: values.service?.key || "",
      product: values.product || "",
      packageCode: values.packageCode?.trim() || "",
      description: values.description?.trim() || "",
      ticketDetail: values.ticketDetail || "",
      ...(isTicketType("tư vấn dịch vụ") && {
        transferUnit: {
          code: values.transferUnit?.code || "",
          name: values.transferUnit?.name || "",
          type: values.transferUnit?.type || "",
        },
        businessProduct: values.businessProduct
          ? values.businessProduct?.trim()
          : "",
        outputPerMonth: `${values.outputPerMonth || ""}`,
      }),
      ...(hostUnit && {
        hostUnit: {
          code: hostUnit,
          name: hostUnitName,
        },
      }),
      ...(values.relatedUnit && {
        relatedUnit: values.relatedUnit || [],
      }),
      customerName: formCustomerInfo?.values?.customerName || "",
      customerPhone: formCustomerInfo?.values?.customerPhone || "",
      customerAddress: formCustomerInfo?.values?.customerAddress || "",
      customerEmail: formCustomerInfo?.values?.customerEmail || "",
    },
  });

  const handleResponse = (res, values, setSubmitting) => {
    if (res.data) {
      formTicket.setFieldValue("packageCode", values.packageCode?.trim() || "");
      formTicket.setFieldValue("description", values.description?.trim() || "");
      formTicket.setFieldValue(
        "businessProduct",
        values.businessProduct?.trim() || ""
      );
      formTicket.setFieldValue("outputPerMonth", values.outputPerMonth || "");
      enqueueSnackbar("Lưu thông tin ticket thành công", {
        variant: "success",
      });
      if (customerInfoDefault) {
        onClose();
      }
    } else {
      enqueueSnackbar("Lưu thông tin ticket thất bại!", {
        variant: "error",
      });
    }
    setSubmitting(false);
  };

  const handleError = (err, setSubmitting) => {
    enqueueSnackbar(
      `Lưu thông tin ticket thất bại! ${
        err.response?.data?.error?.message || err.message || ""
      }`,
      {
        variant: "error",
      }
    );
    setSubmitting(false);
  };

  const handleSubmitTicket = (values, { setSubmitting }) => {
    const requestBody = createRequestBody(values);

    if (customerInfoDefault) {
      postRequest(`/mini-crm/ticket/create-ticket`, {
        ...requestBody,
        source: "outbound",
        logId: idSelectedCustomerCall,
      })
        .then((res) => handleResponse(res, values, setSubmitting))
        .catch((err) => handleError(err, setSubmitting));
    } else {
      putRequest(`/mini-crm/ticket/${idTicketPhone}`, requestBody)
        .then((res) => {
          handleResponse(res, values, setSubmitting);
          onRefreshListPhone(idTicketPhone, phoneTab);
        })
        .catch((err) => handleError(err, setSubmitting));
    }
  };

  const formCustomerInfo = useFormik({
    initialValues: {
      customerName: "",
      customerPhone: "",
      customerAddress: "",
      customerEmail: "",
    },
    onSubmit: handleSubmitCustomerInfo,
    validationSchema: validationSchemaCustomerInfo,
  });

  const formTicket = useFormik({
    initialValues: {
      packageCode: "",
      service: null,
      product: "",
      type: "",
      ticketDetail: "",
      description: "",
      transferUnit: { code: "", name: "", type: "" },
      relatedUnit: [],
      businessProduct: "",
      outputPerMonth: "",
      moreMisson: false,
      task: [],
    },
    onSubmit: handleSubmitTicket,
    validationSchema: validationSchemaTicket,
  });

  // lấy thông tin khách hàng trên crm + thông tin ticket
  const getInfoCustomer = useCallback(async () => {
    let customerInfoData = {};
    let ticketData = {};
    if (customerInfoDefault?.phoneNumber) {
      customerInfoData = {
        customerName: customerInfoDefault?.fullName ?? "",
        customerPhone: customerInfoDefault?.phoneNumber ?? "",
        customerAddress: customerInfoDefault?.address ?? "",
        customerEmail: customerInfoDefault?.email ?? "",
      };
      ticketData = {
        service: null,
        product: "",
        packageCode: "",
        type: "",
        ticketDetail: "",
        description: "",
        transferUnit: {
          code: "",
          name: "",
          type: "",
        },
        relatedUnit: [],
        moreMisson: false,
        task: [],
        businessProduct: "",
        outputPerMonth: "",
      };
    } else if (idTicketPhone && phoneTab) {
      customerInfoData = await get(
        `/mini-crm-v2/api/v1/zoho/contacts?phone=${phoneTab}`
      ).then((res) => {
        return {
          customerName:
            (res.data?.data?.firstName ? res.data?.data?.firstName + " " : "") +
            (res.data?.data?.lastName || ""),
          customerPhone: phoneTab, // case chưa có thông tin sđt trên crm
          customerAddress: res.data?.data?.city || "",
          customerEmail: res.data?.data?.email || "",
        };
      });

      ticketData = await get(`/mini-crm/ticket/${idTicketPhone}`).then(
        (res) => {
          setHostUnit(res.data?.attributes?.hostUnit?.code || null);
          setHostUnitName(res.data?.attributes?.hostUnit?.name || null);
          return {
            service:
              SERVICES_OPTIONS.find(
                (item) => item.key === res.data?.attributes?.service
              ) || null,
            product: res.data?.attributes?.product || "",
            packageCode: res.data?.attributes?.packageCode || "",
            type: res.data?.type || "",
            ticketDetail: res.data?.attributes?.ticketDetail || "",
            description: res.data?.attributes?.description || "",
            transferUnit: res.data?.attributes?.transferUnit || {
              code: "",
              name: "",
              type: "",
            },
            relatedUnit: res.data?.attributes?.relatedUnit || [],
            moreMisson: res.data?.tasks?.length > 0 ? true : false,
            task: res.data?.tasks || [],
            businessProduct: res.data?.attributes?.businessProduct || "",
            outputPerMonth: res.data?.attributes?.outputPerMonth || "",
          };
        }
      );

      setProductOptions(
        SERVICES.find((item) => item.key === ticketData.service?.key)?.values ||
          []
      );
    } else {
      formCustomerInfo.resetForm();
      formTicket.resetForm();
      return;
    }
    Object.entries(customerInfoData).forEach(([key, value]) =>
      formCustomerInfo.setFieldValue(key, value)
    );
    Object.entries(ticketData).forEach(([key, value]) =>
      formTicket.setFieldValue(key, value)
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idTicketPhone, phoneTab]);

  useEffect(() => {
    // khi phone tab thay đổi
    getInfoCustomer();
  }, [getInfoCustomer, phoneTab, idTicketPhone]);

  const isTicketType = (ticketTypeName) =>
    !!listTicketTypes &&
    listTicketTypes
      .find((item) => item.id === formTicket.values.type)
      ?.name?.toLowerCase()
      .includes(ticketTypeName);

  const getTicketTypes = (ticketTypeId) => {
    if (ticketTypeId) {
      return (
        listTicketTypes.find((item) => item.id === ticketTypeId)?.ticketTypes ||
        []
      );
    }
    return [];
  };

  return (
    <>
      <div
        style={{
          color: "rgba(0, 0, 0, 0.87)",
          fontWeight: 400,
        }}>
        {showHeader && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 3,
              }}>
              <i
                className="fas fa-ticket-alt"
                style={{
                  fontSize: 18,
                  marginRight: 7,
                  transform: "rotate(-45deg)",
                }}></i>
              <span className={styles?.textTitle}>Tạo Ticket</span>
            </div>
            <Divider />
          </>
        )}

        <form onSubmit={formCustomerInfo.handleSubmit}>
          <Grid container style={{ marginTop: 5, padding: "0px 10px" }}>
            <Grid
              item
              xs={12}
              md={6}
              style={{ display: "flex", marginBottom: 5 }}>
              <div className={classes.titleFlex}>
                <span className={styles?.text}>Số điện thoại: </span>
                <RequiredField />
              </div>
              <TextField
                variant="standard"
                fullWidth
                InputProps={{
                  spellCheck: "false",
                  readOnly: !isCanEdit,
                  type: "tel",
                  classes: { input: styles?.textFieldInputRoot },
                }}
                style={{ marginRight: 10 }}
                {...{
                  ...formCustomerInfo.getFieldProps("customerPhone"),
                  onChange: (e) => {
                    let phoneInputValue = e.target.value;
                    phoneInputValue = phoneInputValue.replace(/[^0-9+]/g, "");
                    formCustomerInfo.setFieldValue(
                      "customerPhone",
                      phoneInputValue
                    );

                    // let maxPhoneLength = 10;
                    // if (phoneInputValue.slice(0, 3) === "+84") {
                    //   maxPhoneLength = 12;
                    // }
                    // if (phoneInputValue.slice(0, 2) === "84") {
                    //   maxPhoneLength = 11;
                    // }
                    // if (phoneInputValue[0] === "0") {
                    //   maxPhoneLength = 10;
                    // }
                    // if (phoneInputValue.length <= maxPhoneLength) {
                    //   phoneInputValue = phoneInputValue.replace(/[^0-9+]/g, "");
                    //   formCustomerInfo.setFieldValue(
                    //     "customerPhone",
                    //     phoneInputValue
                    //   );
                    // }
                  },
                }}
                required
                error={
                  formCustomerInfo.touched.customerPhone &&
                  Boolean(formCustomerInfo.errors.customerPhone)
                }
                helperText={
                  formCustomerInfo.touched.customerPhone &&
                  formCustomerInfo.errors.customerPhone
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{ display: "flex", marginBottom: 5 }}>
              <div className={classes.titleFlex}>
                <span className={styles?.text}>Họ & tên: </span>
                <RequiredField />
              </div>
              <TextField
                variant="standard"
                fullWidth
                inputRef={customerNameInputRef}
                InputProps={{
                  spellCheck: "false",
                  readOnly: !isCanEdit,
                  classes: { input: styles?.textFieldInputRoot },
                }}
                style={{ marginRight: 10 }}
                {...formCustomerInfo.getFieldProps("customerName")}
                error={
                  formCustomerInfo.touched.customerName &&
                  Boolean(formCustomerInfo.errors.customerName)
                }
                helperText={
                  formCustomerInfo.touched.customerName &&
                  formCustomerInfo.errors.customerName
                }
              />
            </Grid>
            <Grid item xs={12} md={6} style={{ display: "flex" }}>
              <div className={classes.titleFlex}>
                <span className={styles?.text}>Email: </span>
              </div>
              <TextField
                variant="standard"
                fullWidth
                InputProps={{
                  spellCheck: "false",
                  readOnly: !isCanEdit,
                  classes: { input: styles?.textFieldInputRoot },
                }}
                style={{ marginRight: 10 }}
                {...formCustomerInfo.getFieldProps("customerEmail")}
                error={
                  formCustomerInfo.touched.customerEmail &&
                  Boolean(formCustomerInfo.errors.customerEmail)
                }
                helperText={
                  formCustomerInfo.touched.customerEmail &&
                  formCustomerInfo.errors.customerEmail
                }
              />
            </Grid>
            <Grid item xs={12} md={6} style={{ display: "flex" }}>
              <div className={classes.titleFlex}>
                <span className={styles?.text}>Địa chỉ: </span>
              </div>
              <TextField
                variant="standard"
                fullWidth
                style={{ marginRight: 10 }}
                InputProps={{
                  spellCheck: "false",
                  readOnly: !isCanEdit,
                  classes: { input: styles?.textFieldInputRoot },
                }}
                {...formCustomerInfo.getFieldProps("customerAddress")}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 10,
            }}>
            {!isCanEdit && !customerInfoDefault && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsCanEdit(true);
                  customerNameInputRef.current.focus();
                }}
                className={styles?.button}
                style={{ marginRight: 10 }}>
                Chỉnh sửa
              </Button>
            )}
            {isCanEdit && (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={
                    formCustomerInfo.isSubmitting || !formCustomerInfo.isValid
                  }
                  className={styles?.button}
                  style={{
                    marginRight: 12,
                  }}>
                  Đồng ý
                  {formCustomerInfo.isSubmitting && (
                    <CircularProgress
                      style={{
                        width: 16,
                        height: 16,
                        marginLeft: 5,
                        color: "white",
                      }}
                    />
                  )}
                </Button>
                <Button
                  onClick={() => {
                    formCustomerInfo.resetForm();
                    formCustomerInfo.setFieldValue(
                      "customerPhone",
                      customerInfo.customerPhone
                    );
                    formCustomerInfo.setFieldValue(
                      "customerEmail",
                      customerInfo.customerEmail
                    );
                    formCustomerInfo.setFieldValue(
                      "customerName",
                      customerInfo.customerName
                    );
                    formCustomerInfo.setFieldValue(
                      "customerAddress",
                      customerInfo.customerAddress
                    );
                    setIsCanEdit(false);
                  }}
                  className={styles?.button}
                  style={{
                    textTransform: "none",
                    marginRight: 10,
                  }}>
                  Hủy bỏ
                </Button>
              </>
            )}
          </div>
        </form>

        <form onSubmit={formTicket.handleSubmit}>
          <div
            style={{
              padding: "0px 10px 10px 10px",
            }}>
            <Grid container style={{ marginTop: 3 }}>
              <Grid item xs={12} sm={8} style={{ display: "flex" }}>
                <div
                  className={`${classes.titleFlex} ${classes.titlePackageCode}`}>
                  <span className={styles?.text}>
                    {" "}
                    Mã tin thu gom/Mã vận đơn:{" "}
                  </span>
                  {/* <RequiredField /> */}
                </div>
                <div style={{ marginTop: 10, flex: 1 }}>
                  <TextField
                    variant="standard"
                    fullWidth
                    {...formTicket.getFieldProps("packageCode")}
                    error={
                      formTicket.touched.packageCode &&
                      Boolean(formTicket.errors.packageCode)
                    }
                    helperText={
                      formTicket.touched.packageCode &&
                      formTicket.errors.packageCode
                    }
                    InputProps={{
                      classes: {
                        input: `${styles?.textFieldInputRoot}`,
                      },
                    }}
                  />
                </div>
              </Grid>

              <Grid item xs={12} sm={4} style={{ display: "flex" }}>
                <div style={{ marginLeft: 15 }}>
                  <IconButton
                    color="inherit"
                    onClick={() =>
                      handleSearchPackage(formTicket.values.packageCode)
                    }
                    className={classes.iconButton}>
                    <Icon>search</Icon>
                  </IconButton>
                  <div style={{ textAlign: "center", lineHeight: 1 }}>
                    <span className={classes.textSmall}>Định vị</span>
                  </div>
                </div>

                <div style={{ marginLeft: 5 }}>
                  <IconButton
                    color="inherit"
                    onClick={() => {}}
                    className={classes.iconButton}
                    disabled>
                    <Icon>search</Icon>
                  </IconButton>
                  <div
                    style={{
                      textAlign: "center",
                      lineHeight: 1,
                      color: "#ccc",
                    }}>
                    <span className={classes.textSmall}>CMS</span>
                  </div>
                </div>

                <div style={{ marginLeft: 5 }}>
                  <IconButton
                    className={classes.iconButton}
                    color="inherit"
                    onClick={() => {}}
                    disabled>
                    <Icon>search</Icon>
                  </IconButton>
                  <div
                    style={{
                      textAlign: "center",
                      lineHeight: 1,
                      color: "#ccc",
                    }}>
                    <span className={classes.textSmall}>PNS</span>
                  </div>
                </div>
              </Grid>

              <Grid
                item
                xs={6}
                style={{ paddingRight: 5 }}
                className={classes.row}>
                <span className={styles?.text}>Dịch vụ:</span>
                <Autocomplete
                  options={SERVICES_OPTIONS}
                  getLabel={(item) => item?.name || ""}
                  onChangeValue={(newServiceValue) => {
                    if (
                      newServiceValue?.key !== formTicket.values.service?.key
                    ) {
                      formTicket.setFieldValue("service", newServiceValue);
                      formTicket.setFieldValue("product", "");
                      setProductOptions(
                        SERVICES.find(
                          (item) => item.key === newServiceValue?.key
                        )?.values || []
                      );
                    }
                  }}
                  value={formTicket.values.service}
                  InputProps={{
                    classes: {
                      input: classes.textFieldOutlinedInputRoot,
                    },
                  }}
                  enableResize
                />
              </Grid>
              <Grid
                item
                xs={6}
                style={{ paddingLeft: 5 }}
                className={classes.row}>
                <span className={styles?.text}>Sản phẩm:</span>
                <Autocomplete
                  margin="dense"
                  options={productOptions}
                  getLabel={(item) => item}
                  onChangeValue={(item) =>
                    formTicket.setFieldValue("product", item)
                  }
                  value={formTicket.values.product}
                  InputProps={{
                    classes: {
                      input: classes.textFieldOutlinedInputRoot,
                    },
                  }}
                  enableResize
                />
              </Grid>
              <Grid item xs={12} className={classes.row}>
                <span className={styles?.text}>Loại yêu cầu: </span>
                <RequiredField />
                <TextField
                  variant="outlined"
                  InputProps={{
                    classes: {
                      input: classes.textFieldOutlinedInputRoot,
                    },
                  }}
                  select
                  fullWidth
                  {...{
                    ...formTicket.getFieldProps("type"),
                    onChange: (event) => {
                      // Doan.nn them truong hop khieu nai
                      const checkSelect =
                        !!listTicketTypes &&
                        listTicketTypes
                          .find((item) => item.id === event.target.value)
                          ?.name?.toLowerCase()
                          .includes("khiếu nại");
                      // if (checkSelect && !formTicket.values.packageCode) {
                      //   antMessage.error(
                      //     "Vui lòng nhập Mã tin thu gom/Mã vận đơn"
                      //   );
                      // } else {
                      formTicket.setFieldValue("transferUnit", {
                        code: "",
                        name: "",
                        type: "",
                      });

                      formTicket.setFieldValue("relatedUnit", []);
                      setHostUnitName("");
                      setHostUnit(null);
                      formTicket.setFieldValue("ticketDetail", "");
                      formTicket.setFieldValue("type", event.target.value);
                      // }
                      if (checkSelect && formTicket.values.packageCode) {
                        handleGetInfoPackage(formTicket.values.packageCode);
                      }
                    },
                  }}
                  error={
                    formTicket.touched.type && Boolean(formTicket.errors.type)
                  }
                  helperText={
                    formTicket.touched.type && formTicket.errors.type
                  }>
                  {listTicketTypes?.map((item) => (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                      classes={{ root: styles?.menuItem }}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {!!getTicketTypes(formTicket.values.type).length && (
                <Grid item xs={12} className={classes.row}>
                  <span className={styles?.text}>Nội dung yêu cầu: </span>
                  <RequiredField />
                  <TextField
                    variant="outlined"
                    InputProps={{
                      classes: {
                        input: classes.textFieldOutlinedInputRoot,
                      },
                    }}
                    select
                    fullWidth
                    {...formTicket.getFieldProps("ticketDetail")}
                    error={
                      formTicket.touched.ticketDetail &&
                      Boolean(formTicket.errors.ticketDetail)
                    }
                    helperText={
                      formTicket.touched.ticketDetail &&
                      formTicket.errors.ticketDetail
                    }>
                    {getTicketTypes(formTicket.values.type).map((item) => (
                      <MenuItem
                        key={item}
                        value={item}
                        classes={{ root: styles?.menuItem }}>
                        {item}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
              <Grid item xs={12} className={classes.row}>
                <span className={styles?.text}>Chi tiết yêu cầu: </span>
                <RequiredField />
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  InputProps={{
                    spellCheck: "false",
                    classes: {
                      multiline: `${classes.textFieldTicketDetail} ${classes.textFieldOutlinedInputRoot}`,
                    },
                  }}
                  rows={3}
                  {...formTicket.getFieldProps("description")}
                  error={
                    formTicket.touched.description &&
                    Boolean(formTicket.errors.description)
                  }
                  helperText={
                    formTicket.touched.description &&
                    formTicket.errors.description
                  }
                />
              </Grid>
              {isTicketType("tư vấn dịch vụ") && (
                <>
                  <Grid item xs={12} className={classes.row}>
                    <span className={styles?.text}>Đơn vị xử lý:</span>
                    {/* <RequiredField /> */}
                    <Autocomplete
                      margin="dense"
                      options={TRANSFER_UNITS}
                      getLabel={(item) =>
                        item?.code ? `${item?.code} - ${item?.name}` : ""
                      }
                      onChangeValue={(item) => {
                        formTicket.setFieldValue("transferUnit", {
                          ...item,
                          type: "city",
                        });
                      }}
                      value={formTicket.values.transferUnit}
                      InputProps={{
                        classes: {
                          input: classes.textFieldOutlinedInputRoot,
                        },
                      }}
                      error={Boolean(formTicket.errors?.transferUnit?.code)}
                      helperText={formTicket.errors?.transferUnit?.code}
                      enableResize
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex" }}
                    className={classes.row}>
                    <div className={classes.titleFlex}>
                      <span className={styles?.text}>
                        Mặt hàng kinh doanh:{" "}
                      </span>
                    </div>
                    <TextField
                      variant="standard"
                      fullWidth
                      {...formTicket.getFieldProps("businessProduct")}
                      InputProps={{
                        classes: { input: styles?.textFieldInputRoot },
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    className={classes.row}
                    style={{ display: "flex" }}>
                    <div className={classes.titleFlex}>
                      <span className={styles?.text}>Sản lượng/tháng: </span>
                    </div>
                    <TextField
                      variant="standard"
                      fullWidth
                      {...formTicket.getFieldProps("outputPerMonth")}
                      InputProps={{
                        type: "number",
                        classes: { input: styles?.textFieldInputRoot },
                      }}
                    />
                  </Grid>
                </>
              )}
              {/* Don vi chu tri */}
              {isTicketType("khiếu nại") && (
                <>
                  <Grid
                    item
                    xs={6}
                    style={{ paddingRight: 5 }}
                    className={classes.row}>
                    <span className={styles?.text}>Đơn vị chủ trì: </span>
                    <AntInput
                      value={hostUnitName}
                      style={{ height: "54px" }}
                      disabled
                    />
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    style={{ paddingLeft: 5 }}
                    className={classes.row}>
                    <span className={styles?.text}>Đơn vị liên quan:</span>

                    <AntSelect
                      showSearch
                      optionFilterProp="children"
                      style={{ width: "100%" }}
                      mode="multiple"
                      showArrow={true}
                      optionLabelProp="code"
                      value={(formTicket.values.relatedUnit || []).map(
                        (item) => `${item.type}${item.code}`
                      )}
                      onChange={(value, option) => {
                        const list = option.map((item) => {
                          return {
                            code: item.code || "",
                            name: item.label || "",
                            type: item.type || "",
                          };
                        });
                        // console.log(list);
                        formTicket.setFieldValue("relatedUnit", list);
                      }}
                      onSearch={(value) => {
                        if (value) {
                          searchProvince(value, getProvice);
                        }
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        ...TRANSFER_UNITS.map((item) => ({
                          label: `${item.code || ""} - ${item.name || ""}`,
                          value: `city${item.code}`,
                          code: item.code,
                          type: "city",
                        })),
                        ...(subOrgs || []).map((item) => ({
                          label: item.fullname || "",
                          value: `subOrg${item.code}`,
                          code: item.code,
                          type: "subOrg",
                        })),
                      ]}
                    />
                  </Grid>
                </>
              )}

              {/* Thêm nhiem vu */}
              <FormikProvider value={formTicket}>
                <FieldArray
                  name="task"
                  render={(arrayHelpers) => (
                    <>
                      <Grid item xs={12} className={classes.row}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(_event, checked) => {
                                if (checked)
                                  arrayHelpers.insert(0, {
                                    type: "",
                                    description: "",
                                    actionDate: moment()
                                      .startOf("day")
                                      .toISOString(),
                                  });
                                else arrayHelpers.remove(0);
                                formTicket.setFieldValue("moreMisson", checked);
                              }}
                              value={formTicket.values.moreMisson}
                              checked={formTicket.values.moreMisson}
                              color="primary"
                              classes={{
                                root: classes.checkBox,
                              }}
                              disabled={!!isCanEdit}
                            />
                          }
                          classes={{
                            root: classes.formControlLabelRoot,
                            label: classes.label,
                          }}
                          label="Thêm nhiệm vụ"
                        />
                      </Grid>
                      {(formTicket.values.task || []).map((_, index) => (
                        <Grid container key={index}>
                          <Grid item xs={6} className={classes.row}>
                            <div className={classes.label}>
                              Loại nhiệm vụ <RequiredField />
                            </div>
                            <TextField
                              select
                              variant="outlined"
                              {...formTicket.getFieldProps(
                                `task.${index}.type`
                              )}
                              fullWidth
                              InputProps={{
                                classes: {
                                  input: classes.input,
                                },
                              }}
                              error={
                                formTicket.touched.task?.[index]?.type &&
                                Boolean(formTicket.errors.task?.[index]?.type)
                              }
                              helperText={
                                formTicket.touched.task?.[index]?.type &&
                                formTicket.errors.task?.[index]?.type
                              }
                              style={{ paddingRight: 10 }}
                              disabled={!!isCanEdit}>
                              {LIST_MISSION_TYPES?.map((missionType) => (
                                <MenuItem
                                  key={missionType.id}
                                  value={missionType.value}
                                  classes={{
                                    root: classes.input,
                                  }}>
                                  {missionType.name}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid item xs={6} className={classes.row}>
                            <div className={classes.label}>
                              Thời gian thực hiện <RequiredField />
                            </div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <InlineDatePicker
                                name="date"
                                variant="outlined"
                                format="dd-MM-yyyy"
                                minDate={new Date()}
                                {...formTicket.getFieldProps(
                                  `task.${index}.actionDate`
                                )}
                                value={
                                  formTicket.values.task?.[index]?.actionDate
                                    ? new Date(
                                        formTicket.values.task?.[
                                          index
                                        ]?.actionDate
                                      )
                                    : null
                                }
                                onChange={(date) => {
                                  formTicket.setFieldValue(
                                    `task.${index}.actionDate`,
                                    moment(date).startOf("day").toISOString()
                                  );
                                }}
                                error={
                                  formTicket.touched.task?.[index]
                                    ?.actionDate &&
                                  Boolean(
                                    formTicket.errors.task?.[index]?.actionDate
                                  )
                                }
                                helperText={
                                  formTicket.touched.task?.[index]
                                    ?.actionDate &&
                                  formTicket.errors.task?.[index]?.actionDate
                                }
                                InputProps={{
                                  classes: {
                                    input: classes.input,
                                  },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <i
                                        className="far fa-calendar-alt"
                                        style={{
                                          color: "#757575",
                                          cursor: "pointer",
                                        }}></i>
                                    </InputAdornment>
                                  ),
                                }}
                                disabled={!!isCanEdit}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item xs={12} className={classes.row}>
                            <span className={classes.label}>
                              Chi tiết nhiệm vụ <RequiredField />
                            </span>

                            <TextField
                              variant="outlined"
                              fullWidth
                              multiline
                              InputProps={{
                                spellCheck: "false",
                                classes: {
                                  root: classes.input,
                                  multiline: classes.label,
                                },
                              }}
                              rows={3}
                              {...formTicket.getFieldProps(
                                `task.${index}.description`
                              )}
                              error={
                                formTicket.touched.task?.[index]?.description &&
                                Boolean(
                                  formTicket.errors.task?.[index]?.description
                                )
                              }
                              helperText={
                                formTicket.touched.task?.[index]?.description &&
                                formTicket.errors.task?.[index]?.description
                              }
                              disabled={!!isCanEdit}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    </>
                  )}
                />
              </FormikProvider>

              <Grid item xs={12} style={{ display: "flex" }}>
                {/* <div className={classes.titleFlex}>Tasks:</div>
                    <RadioGroup name="value" onChange={() => {}}>
                      <FormControlLabel
                        value="new"
                        control={<Radio />}
                        label={<span style={{ color: "blue" }}>Thêm task</span>}
                      />
                      <FormControlLabel
                        value="new-title"
                        control={<Radio />}
                        label="--Title--"
                      />
                      <div style={{ marginLeft: 25 }}>
                        <div>
                          <i
                            className="fas fa-list-alt"
                            style={{ fontSize: 22, marginRight: 10 }}
                          ></i>
                          <span>--Nội dung--</span>
                        </div>
                        <div>
                          <i
                            className="far fa-calendar-alt"
                            style={{ fontSize: 25, marginRight: 10 }}
                          ></i>

                          <span>Date/time</span>
                        </div>
                      </div>

                      <FormControlLabel
                        value="call"
                        control={<Radio />}
                        label="Gọi cho khách"
                      />

                      <div style={{ marginLeft: 25, position: "relative" }}>
                        <span
                          style={{
                            border: "1px solid black",
                            borderRadius: "50%",
                            padding: 10,
                          }}
                        >
                          Ngày mai, 10:00
                        </span>
                        <i
                          className="far fa-angle-double-right"
                          style={{
                            fontSize: 28,
                            color: "orange",
                            position: "absolute",
                            top: "-20px",
                            right: "-40px",
                            cursor: "pointer",
                          }}
                        ></i>
                      </div>
                    </RadioGroup> */}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    margin: "10px 0px 10px 0px",
                    flex: 1,
                  }}>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={
                      customerInfoDefault
                        ? formTicket.isSubmitting ||
                          !formTicket.isValid ||
                          isCanEdit
                        : formTicket.isSubmitting ||
                          !formTicket.isValid ||
                          !idTicketPhone ||
                          isCanEdit
                    }
                    type="submit"
                    className={styles?.button}>
                    Tạo ticket
                    {formTicket.isSubmitting && (
                      <CircularProgress
                        style={{
                          width: 18,
                          height: 18,
                          marginLeft: 5,
                          color: "white",
                        }}
                      />
                    )}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </form>
      </div>
      <DialogDragable
        open={openDialogPackage}
        onClose={() => setOpenDialogPackage(false)}
        title={
          <span>
            Thông tin bưu gửi{" "}
            <span style={{ fontSize: 20, color: "red" }}>{packageCode}</span>
          </span>
        }
        isLoading={isLoadingPackage}>
        <PackageInfo packageInfo={packageInfo} />
      </DialogDragable>
    </>
  );
};

const RequiredField = () => <span style={{ color: "red" }}>(*)</span>;
export default withStyles(styles)(NewTicket);
